import { z } from "zod";
export const languageSchema = z.enum(["en", "he"]);
export const weightUnitSchema = z.enum(["kg", "lb"]);
export const PASSWORD_MIN_LENGTH = 10;
// Upper bound stops a multi-megabyte "password" from being fed to argon2.
export const PASSWORD_MAX_LENGTH = 128;
// Normalise before validating so "  Me@Example.COM " and "me@example.com" are one account.
export const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));
export const registerBodySchema = z.object({
    email: emailSchema,
    password: z.string().min(PASSWORD_MIN_LENGTH).max(PASSWORD_MAX_LENGTH),
    displayName: z.string().trim().min(1).max(80).optional(),
    language: languageSchema.default("en"),
});
// Login deliberately does not enforce the register-time minimum: it must accept
// whatever the account was created with, and say nothing about password rules.
export const loginBodySchema = z.object({
    email: emailSchema,
    password: z.string().min(1).max(PASSWORD_MAX_LENGTH),
});
export const profileSchema = z.object({
    id: z.uuid(),
    email: z.string(),
    displayName: z.string().nullable(),
    language: languageSchema,
    weightUnit: weightUnitSchema,
});
// Settings screen: language and unit, plus the display name. null clears the name.
export const updateMeBodySchema = z
    .object({
    displayName: z.string().trim().min(1).max(80).nullable().optional(),
    language: languageSchema.optional(),
    weightUnit: weightUnitSchema.optional(),
})
    .refine((body) => Object.keys(body).length > 0, { message: "at least one field is required" });
// Deleting an account asks for the password again, so a stolen session alone cannot do it.
export const deleteAccountBodySchema = z.object({ password: z.string().min(1).max(PASSWORD_MAX_LENGTH) });
export const profileResponseSchema = z.object({ profile: profileSchema });
export const errorResponseSchema = z.object({
    error: z.string(),
    issues: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
//# sourceMappingURL=auth.js.map